<template>
  <div>
    <ul class="collections">
      <li v-for="(collection, key) in sectionLinks" class="collection" :class="collectionClassName" :key="key">
        <router-link v-if="isServer" :to="localizedUrl + collection.link" @click.native="
          callGTM({
            event: 'menuClick',
            menuLevel1: externalMenuLabel,
            menuLevel2: collection.title
          })"
        >
          <p class="h5" v-if="collection.title" v-text="$t(collection.title)"></p>
          <span v-if="collection.subtitle" v-text="$t(collection.subtitle)"></span>
        </router-link>
        <NoSSR>
          <collection-item
            is-thumbs="true"
            :link-label="collectionsGroup.linkLabel"
            has-collection-link-label="true"
            @collection-item-clicked="callGTMCallback(collection)"
            h-ci18n="true" :collection="collection"
          ></collection-item>
        </NoSSR>
      </li>
    </ul>
    <router-link
      v-if="collectionsGroup.ctaLink"
      class="see-all link-light -reverse d-inline-flex align-items-center justify-content-between"
      :to="`${localizedUrl}/${collectionsGroup.ctaLink}`"
      @click.native="$emit('close'); callGTM({
        event: 'menuClick',
        menuLevel1: externalMenuLabel,
        menuLevel2: $t(collectionsGroup.cta)
      })"
    >
      <span v-text="$t(collectionsGroup.cta)"></span>
      <i class="ml-3 mr-0 icon-next"></i>
    </router-link>
  </div>
</template>
<script>
import { currentStoreView } from '@vue-storefront/core/lib/multistore'
import NoSSR from 'src/themes/zenith/node_modules/vue-no-ssr'

export default {
  name: 'CollectionsGroup',
  props: {
    sectionLinks: {
      type: Array,
      required: true
    },
    collectionsGroup: {
      type: Object,
      required: true
    },
    isServer: {
      type: Boolean,
      default: false
    },
    collectionClassName: {
      type: String,
      default: ''
    },
    externalMenuLabel: {
      type: String,
      required: true
    }
  },
  components: {
    NoSSR,
    CollectionItem: () =>
      import(/* webpackChunkName: "collection-item-cpt" */ '../CollectionItem.vue')
  },
  computed: {
    localizedUrl () {
      return currentStoreView().url || ''
    }
  },
  methods: {
    callGTM (gtmObject) {
      if (gtmObject && gtmObject.event) {
        this.$gtm.trackEvent(gtmObject)
      }
    },
    callGTMCallback (collection) {
      collection.clickCallback && collection.clickCallback();
      this.callGTM({
        event: 'menuClick',
        menuLevel1: this.externalMenuLabel,
        menuLevel2: collection.title
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~theme/css/core';

.collections {
  --_column-gap: 1rem;
  --_number-of-items: 4;
  transition: all 0.4s ease-in-out;
  list-style: none;
  display: flex;
  gap: 3rem var(--_column-gap);
  padding-bottom: 3rem;

  &:has(.-watches) {
    margin-bottom: 3rem;
    border-bottom: 0.1rem solid var(--_zenith-color-transparent);
  }

  @include bp(max md) {
    flex-wrap: wrap;
    padding: 2.5rem 0;
  }

  .collection {
    /* Formula: (100% - (number of gaps × gap size)) / number of items */
    flex: 1;
    flex-basis: calc((100% / var(--_number-of-items)) - (var(--_column-gap) * ((var(--_number-of-items) - 1) / var(--_number-of-items))));

    @include bp(max md) {
      flex-grow: 0;
      max-width: 50%;
      --_number-of-items: 2;
    }

    /deep/ a {
      &.thumbs {
        justify-content: flex-start;
        height: 100%;
      }

      .collection-item-title {
        width: 100%;
      }

      .subtitle {
        display: none;

      }
      @include bp(max md) {
        .font-smaller {
          font-size: 1.2rem;
        }
      }

      &:before {
        display: none;
      }

      .collection-item-link__text {
        margin-right: 0.5rem;
        color: var(--_zenith-header-text-link);
        font-size: 1.2rem;
        font-weight: 300;

        &::before {
          background: var(--_zenith-header-text-link);
          width:0;
        }
      }

      &:hover,
      &:focus {
        .collection-item-link__text::before {
          width: 100%;
        }
      }
    }
  }

  &+.see-all {
    margin-left: 4rem;
    color: var(--_zenith-header-text-link);
    font-size: 1.6rem;
    font-weight: 300;

    &::before {
      background: var(--_zenith-header-text-link);
    }

    @include bp(max md) {
      width: 100%;
      margin: 0 0 2.5rem;
    }
  }
}

</style>
